import { Stack } from "@mui/material";
import PlayerItemMinimal from "./PlayerItemMinimal";
import EmptyCard from "./EmptyCard";

interface ProColorMapping {
  PROS: Record<number, [string, string]>;
  PLAYERS: Record<number, number>;
  MAPPING: Record<number, string>;
}

interface PlayerListMinimalProps {
  managerMode: number;
  playerList: Record<string, any[]>;
  team: string;
  chukker: string;
  useUSPARating: boolean;
  isBench: boolean;
  proColorMapping?: ProColorMapping;
  betaMode: boolean;
}

function PlayerListMinimal(props: PlayerListMinimalProps) {
  if (Object.entries(props.playerList).length === 0) {
    return <EmptyCard />;
  }

  return (
    <Stack spacing={0.5}>
      {Object.entries(props.playerList).map(([key, players]) => {
        // Extract horseId from player data array (index 11) or from horseId property
        const horseId = (players as any).horseId || 
                       (Array.isArray(players) && players.length > 11 && players[11] !== null && players[11] !== undefined 
                         ? String(players[11]) 
                         : undefined);
        return (
          <PlayerItemMinimal
            id={key}
            key={key}
            managerMode={props.managerMode}
            index={players[3]}
            firstName={players[4]}
            lastName={players[5]}
            rating={props.useUSPARating ? players[6] : players[7]}
            chukker={props.chukker}
            team={props.team}
            isBench={props.isBench}
            proColorMapping={props.proColorMapping}
            betaMode={props.betaMode}
            playerId={players[3]}
            horseId={horseId}
          />
        );
      })}
    </Stack>
  );
}

export default PlayerListMinimal;

